import { inject, Injectable } from '@angular/core';
import { AuthTokens, TokenStorage } from '@libs/shared-services';
import { authActions } from '@libs/store';
import { localStorageKey, throwError } from '@libs/utils';
import { Store } from '@ngrx/store';
import { DateTime } from 'luxon';

@Injectable()
export class LocalStoreTokenStorageService extends TokenStorage {
  private readonly store = inject(Store);

  public storeAuthTokens(tokens: AuthTokens, options: { isUserActivity: boolean }): void {
    localStorage.setItem(localStorageKey.auth, JSON.stringify(tokens));

    if (tokens.refreshTokenExpirationTimestamp) {
      this.store.dispatch(
        authActions.refreshTokensAvailable({
          refreshTokenExpiry: DateTime.fromSeconds(tokens.refreshTokenExpirationTimestamp),
          isUserActivity: options.isUserActivity,
        }),
      );
    }
  }

  public loadAuthTokens(): AuthTokens | null {
    try {
      const loadedTokens = JSON.parse(
        localStorage.getItem(localStorageKey.auth) ?? throwError('No tokens stored are available'),
      ) as Partial<AuthTokens>;

      if (
        typeof loadedTokens.accessToken !== 'string' ||
        typeof loadedTokens.refreshToken !== 'string' ||
        typeof loadedTokens.refreshTokenExpirationTimestamp !== 'number' ||
        typeof loadedTokens.accessTokenExpirationTimestamp !== 'number'
      ) {
        throwError('Stored tokens are malformed');
      }

      return loadedTokens as AuthTokens;
    } catch {}

    return null;
  }

  public deleteAuthTokens(): void {
    localStorage.removeItem(localStorageKey.auth);
  }
}
